import { render, staticRenderFns } from "./InvoicesMain.vue?vue&type=template&id=782edf20&scoped=true&"
import script from "./InvoicesMain.vue?vue&type=script&lang=js&"
export * from "./InvoicesMain.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesMain.vue?vue&type=style&index=0&id=782edf20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782edf20",
  null
  
)

export default component.exports